export enum OrderProcessingType {
    Manual = 0,
    Taker = 1,
    Maker = 2,
}
